export const SearchHomeSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={200} height={200} fill="none">
    <path
      fill="#0038FF"
      d="M189.076 66.822c-4.58-11.162-11.6-21.512-20.619-29.356-10.577-9.2-27.263-16.29-41.371-11.276-14.598 5.19-24.365 17.631-35.192 27.746-3.802 3.553-7.961 6.921-12.894 8.899-22.593 9.056-37.938-3.293-57.972 10.702-20.035 13.996-21.74 41.987-8.526 59.687 13.215 17.701 44.758 15.231 68.629 15.231 23.871 0 20.034 16.877 61.809 17.289 42.72.421 56.206-44.897 51.586-78.813-.921-6.754-2.767-13.571-5.45-20.11Z"
    />
    <path
      fill="#fff"
      d="M189.076 66.822c-4.58-11.162-11.6-21.512-20.619-29.356-10.577-9.2-27.263-16.29-41.371-11.276-14.598 5.19-24.365 17.631-35.192 27.746-3.802 3.553-7.961 6.921-12.894 8.899-22.593 9.056-37.938-3.293-57.972 10.702-20.035 13.996-21.74 41.987-8.526 59.687 13.215 17.701 44.758 15.231 68.629 15.231 23.871 0 20.034 16.877 61.809 17.289 42.72.421 56.206-44.897 51.586-78.813-.921-6.754-2.767-13.571-5.45-20.11Z"
      opacity={0.7}
    />
    <path
      fill="#0038FF"
      d="M93.987 38.589c-2.764-1.508-4.02-.252-5.025-1.508-1.005-1.256 2.763-4.523-4.774-7.789 0 0-.502-7.035-10.804-7.286-10.301-.251-7.538 7.035-10.301 8.794-2.764 1.759-3.518-1.005-6.281.754-2.764 1.759-1.508 5.276-3.77 5.779-2.26.502-5.276-2.262-8.04-.503-2.763 1.759-2.763 3.266-4.02 3.266-1.256 0-3.768-1.005-5.276 0-1.507 1.005-3.266 2.261-3.266 2.261h63.566s.754-2.261-2.01-3.768Z"
    />
    <path
      fill="#fff"
      d="M93.987 38.589c-2.764-1.508-4.02-.252-5.025-1.508-1.005-1.256 2.763-4.523-4.774-7.789 0 0-.502-7.035-10.804-7.286-10.301-.251-7.538 7.035-10.301 8.794-2.764 1.759-3.518-1.005-6.281.754-2.764 1.759-1.508 5.276-3.77 5.779-2.26.502-5.276-2.262-8.04-.503-2.763 1.759-2.763 3.266-4.02 3.266-1.256 0-3.768-1.005-5.276 0-1.507 1.005-3.266 2.261-3.266 2.261h63.566s.754-2.261-2.01-3.768Z"
      opacity={0.5}
    />
    <path
      fill="#fff"
      d="M146.163 49.206c-1.776-.969-2.583-.162-3.229-.969-.645-.806 1.776-2.905-3.067-5.003 0 0-.323-4.52-6.941-4.681-6.618-.161-4.842 4.52-6.618 5.65-1.775 1.13-2.26-.646-4.035.484-1.776 1.13-.968 3.39-2.422 3.712-1.452.323-3.389-1.452-5.165-.322-1.775 1.13-1.775 2.098-2.582 2.098-.807 0-2.422-.645-3.39 0a93.498 93.498 0 0 0-2.099 1.453h40.838c.001 0 .485-1.454-1.29-2.422Z"
    />
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
    >
      <path fill="#fff" d="M163.759 95.439H34.037v40.934H163.76V95.439Z" />
      <path fill="#0038FF" d="M99.07 58.09 34.38 95.44H163.76L99.07 58.09Z" />
    </g>
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M125.181 92.112h-32.1v44.261h32.1v-44.26Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M125.181 92.112h-32.1v1.883h32.1v-1.883ZM117.147 136.373h-16.032v-27.666a8.016 8.016 0 0 1 16.032 0v27.666Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M99.078 102.609H24.723v33.764h74.355v-33.764Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M99.078 102.609H24.723v1.506h74.355v-1.506Z"
    />
    <path
      fill="#0038FF"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M90.897 105.394H32.904v30.979h57.993v-30.979ZM61.901 77.907 22.44 100.69h78.924L61.901 77.907Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M101.363 100.69H22.439v1.919h78.924v-1.919Z"
    />
    <path
      fill="#0038FF"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="m109.13 79.265-20.437 11.8h40.874l-20.437-11.8Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M129.566 91.064H88.693v1.894h40.873v-1.894Z"
    />
    <g
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
    >
      <path d="M39.714 107.884h-4.696v4.696h4.696v-4.696ZM46.76 107.884h-4.697v4.696h4.696v-4.696ZM53.804 107.884h-4.697v4.696h4.697v-4.696ZM60.849 107.884h-4.697v4.696h4.697v-4.696ZM67.894 107.884h-4.697v4.696h4.697v-4.696ZM74.937 107.884H70.24v4.696h4.697v-4.696ZM81.982 107.884h-4.697v4.696h4.697v-4.696ZM89.027 107.884H84.33v4.696h4.697v-4.696ZM39.714 114.795h-4.696v4.697h4.696v-4.697ZM46.76 114.795h-4.697v4.697h4.696v-4.697ZM53.804 114.795h-4.697v4.697h4.697v-4.697ZM60.849 114.795h-4.697v4.697h4.697v-4.697ZM67.894 114.795h-4.697v4.697h4.697v-4.697ZM74.937 114.795H70.24v4.697h4.697v-4.697ZM81.982 114.795h-4.697v4.697h4.697v-4.697ZM89.027 114.795H84.33v4.697h4.697v-4.697ZM39.714 121.706h-4.696v4.696h4.696v-4.696ZM46.76 121.706h-4.697v4.696h4.696v-4.696ZM53.804 121.706h-4.697v4.696h4.697v-4.696ZM60.849 121.706h-4.697v4.696h4.697v-4.696ZM67.894 121.706h-4.697v4.696h4.697v-4.696ZM74.937 121.706H70.24v4.696h4.697v-4.696ZM81.982 121.706h-4.697v4.696h4.697v-4.696ZM89.027 121.706H84.33v4.696h4.697v-4.696ZM39.714 128.617h-4.696v4.696h4.696v-4.696ZM46.76 128.617h-4.697v4.696h4.696v-4.696ZM53.804 128.617h-4.697v4.696h4.697v-4.696ZM60.849 128.617h-4.697v4.696h4.697v-4.696ZM67.894 128.617h-4.697v4.696h4.697v-4.696ZM74.937 128.617H70.24v4.696h4.697v-4.696ZM81.982 128.617h-4.697v4.696h4.697v-4.696ZM89.027 128.617H84.33v4.696h4.697v-4.696Z" />
    </g>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M104.352 131.458v4.915"
    />
    <path fill="#222" d="M112.981 136.373v-26.141h-8.629v19.062" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M112.981 136.373v-26.141h-8.629v19.062"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M167.435 136.373h-47.427v-44.26l23.713-12.848 23.714 12.847v44.261Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="m171.061 93.995-27.339-14.812-27.338 14.811-.851-1.57 28.189-15.272 28.19 15.273-.851 1.57Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M120.008 92.112v1.076l23.713-12.847 23.714 12.847v-1.076l-23.714-12.847-23.713 12.847Z"
    />
    <path fill="#fff" d="M133.346 102.861v-4.666h20.463v23.26" />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M133.346 102.861v-4.666h20.463v23.26"
    />
    <path fill="#fff" d="M153.809 123.857v4.578h-20.463v-23.798" />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M153.809 123.857v4.578h-20.463v-23.798"
    />
    <g
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
    >
      <path d="M152.446 107.283h-7.958v5.531h7.958v-5.531ZM152.446 114.632h-7.958v5.531h7.958v-5.531ZM152.446 99.56h-7.958v5.904h7.958v-5.905ZM142.669 99.56h-7.958v5.904h7.958v-5.905ZM142.669 114.632h-7.958v5.531h7.958v-5.531ZM142.669 107.283h-7.958v5.531h7.958v-5.531ZM152.446 121.982h-7.958v5.089h7.958v-5.089ZM142.669 121.982h-7.958v5.089h7.958v-5.089Z" />
    </g>
    <g
      stroke="#222"
      strokeDasharray="2.38 4.76"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
    >
      <path d="M134.053 154.63h9.879M37.73 46.781h-1.235a7.41 7.41 0 0 0-7.41 7.41v93.029a7.41 7.41 0 0 0 7.41 7.409h89.737M161.221 54.19a7.41 7.41 0 0 0-7.41-7.409H44.316" />
    </g>
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
    >
      <path
        fill="#fff"
        d="M161.027 57.753c-16.861.095-30.453 13.841-30.359 30.703.095 16.861 13.841 30.453 30.703 30.358 16.861-.095 30.453-13.841 30.358-30.702-.095-16.861-13.841-30.453-30.702-30.359Zm.31 55.033c-13.532.076-24.564-10.832-24.64-24.364-.076-13.532 10.832-24.564 24.364-24.64 13.531-.076 24.563 10.832 24.64 24.364.076 13.532-10.832 24.563-24.364 24.64Z"
      />
      <path
        fill="#fff"
        d="M161.017 56.003c-16.861.096-30.453 13.841-30.358 30.703.095 16.861 13.841 30.453 30.702 30.358 16.861-.095 30.453-13.841 30.358-30.702-.095-16.861-13.841-30.453-30.702-30.359Zm.309 55.033c-13.531.076-24.563-10.832-24.64-24.364-.076-13.532 10.832-24.564 24.364-24.64 13.532-.076 24.564 10.832 24.64 24.364.077 13.532-10.831 24.563-24.364 24.64Z"
      />
      <path
        fill="#0038FF"
        d="m164.039 144.955-4.643.026a1.373 1.373 0 0 1-1.381-1.366l-.138-24.477a1.373 1.373 0 0 1 1.365-1.381l4.643-.027a1.373 1.373 0 0 1 1.381 1.366l.138 24.478a1.373 1.373 0 0 1-1.365 1.381Z"
      />
      <path
        fill="#222"
        d="m164.672 177.966-6.242.034a3.48 3.48 0 0 1-3.498-3.46l-.02-36.538a2.72 2.72 0 0 1 2.704-2.735l7.762-.044a2.72 2.72 0 0 1 2.735 2.704l.019 36.54a3.48 3.48 0 0 1-3.46 3.499Z"
      />
    </g>
  </svg>
)
